// @flow
import * as React from 'react';

import { Base, type DialogStateProps } from '@gandi/ui';

import { ErrorBoundary, sendErrorReport } from 'src/helpers/ErrorBoundary';

import { useExtendedSuggestion } from '../modules';

import { Offers } from './Offers';
import { ProvidedRow } from './ProvidedRow';

import styles from './AvailableRow.scss';

type Props = {
  fqdn: string,
  hasBundle?: boolean,
  phasesDialogState: DialogStateProps,
};

export function AvailableRow({
  fqdn,
  hasBundle,
  phasesDialogState,
}: Props): React.MixedElement {
  const { suggestion } = useExtendedSuggestion({
    fqdn,
  });

  const [displayXSellHosting, setDisplayXSellHosting] = React.useState<boolean>(
    !!suggestion?.addedToCart,
  );

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    setIsLoading(prev => !prev);
  }, [suggestion?.addedToCart]);

  function showXSell(show: boolean) {
    setDisplayXSellHosting(show);

    setIsLoading(true);
  }

  return (
    <div className={styles.root}>
      <Base key={fqdn} backgroundColor="surface">
        <ErrorBoundary
          fallback={<ProvidedRow.Error fqdn={fqdn} />}
          onError={sendErrorReport}
        >
          <ProvidedRow
            fqdn={fqdn}
            showXSell={showXSell}
            phasesDialogState={phasesDialogState}
          />
        </ErrorBoundary>
      </Base>
      <Offers
        fqdn={fqdn}
        showXSell={displayXSellHosting}
        hasBundle={hasBundle}
        isLoading={isLoading}
      />
    </div>
  );
}
